module.exports = __webpack_public_path__ + "static/media/gift-2.86653050.png";